<!-- <li role="presentation" class="dropdown loggeduser">
 -->
<ng-template [ngIf]="userdata">
<!--  <a
	class="dropdown-toggle" [attr.data-toggle]="'dropdown'" href="#" [attr.role]="'button'"
	aria-haspopup="true" aria-expanded="false">{{ userdata.nome + ' ' + userdata.cognome }} <em>
	{{ 'Accesso ' + (userdata.dataLogin | dateformatter:'HH:mm')  }}</em>
</a>-->
<p *ngIf="!hideInfo; else responsiveLayout">
  {{ userdata.nome + ' ' + userdata.cognome }}
  <!--<em>
    {{ 'Accesso ' + (userdata.dataLogin | dateformatter:'HH:mm')  }}
    <br/><br/><a href="#" (click)="logout()"> <p>Logout</p> </a>-->
    <br>
    <label *ngIf="able == false" for="tenantSelect" class="sr-only">{{loginTenantLabel}}</label>
    <select id="tenantSelect" class="form-control-tenant"(change)="selectChangeHandler()" [(ngModel)]="selectedTenant" *ngIf="able == false">
      <option [value]="null" hidden>{{loginTenant}}</option> <!--default option-->
      <option *ngFor="let tenant of userTenants" style="line-height: 10px;" [value]="tenant.id" >{{tenant.label}}</option>
    </select>
    <label class="tenant-selected" *ngIf="able">{{loginTenantLabel}}</label>    
    <em style="position: relative;">
      {{ 'Accesso ' + (userdata.dataLogin | dateformatter:'HH:mm')  }}
      <br/><br/>
      <ng-container *ngComponentOutlet="dynamicInjection?.component;" />
      <button
        type="button"
        class="aChangePwd btn-link"
        [hidden]="!viewButtonProfiloUtente || viewButtonProfiloUtente === 'false'"
        (click)="navigateToUserProfile()"
        aria-label="Apri il profilo utente in una nuova finestra"
        appTooltip="Profilo utente"
        placement="bottom"
        [appTooltipEnabled]="true">
        <span class="glyphicon glyphicon-cog" aria-hidden="true"></span>
      </button>

      <button 
        type="button"
        class="aLogout btn-link"
        (click)="logout()" 
        aria-label="Disconnettiti da Teleforum"
        appTooltip="Logout"
        placement="bottom"
        [appTooltipEnabled]="true">
          <span class="glyphicon glyphicon-off" aria-hidden="true"></span>
      </button>

    </em>
</p>

<ng-template #responsiveLayout>
  <div class="user-access-infos">
    <div>
      {{userdata.dataLogin ?  'Accesso ' + (userdata.dataLogin | dateformatter:'HH:mm') : '' }}
    </div>
    <div style="text-align: end; position: relative;">
      <ng-container *ngComponentOutlet="dynamicInjection?.component;" />
      <button
        type="button"
        class="aChangePwd btn-link"
        [hidden]="!viewButtonProfiloUtente || viewButtonProfiloUtente === 'false'"
        (click)="navigateToUserProfile()"
        aria-label="Apri il profilo utente in una nuova finestra"
        appTooltip="Profilo utente"
        placement="bottom"
        [appTooltipEnabled]="true">
        <span class="glyphicon glyphicon-cog" aria-hidden="true"></span>
      </button>
      <a href="#" class="aLogout" (click)="logout()" title="Logout"><span class="glyphicon glyphicon-off icon-responsive"></span> </a>
    </div>
  </div>
</ng-template>


</ng-template>
<!-- 	</li> -->
<div class="modal fade" id="tenantLogged" tabindex="-1" role="dialog" style="display: none;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="col-sm-12 coldx">
        <p>Attenzione</p>
        <p id="allert-tenant-p-logged">
          Accesso alla piattaforma come <strong>{{loginTenantLabel}}</strong>
        </p>
        <button class="btn btn-default-reverse btn-block btn-sm bt-tenant"
                data-dismiss="modal" type="button">Continua</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="tenantChoice" tabindex="-1" role="dialog" style="display: none;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <p class="col-sm-2 col-sm-offset-10"></p>
      <div class="col-sm-12 coldx">
        <p>Attenzione</p>
        <p id="allert-tenant-p-choice">
          Accedere alla piattaforma come <strong>{{labelTenant}}</strong> ?
        </p>
        <button class="btn btn-default-reverse btn-sm bt-tenant-close"
                data-dismiss="modal" type="button" (click)="cancel()">Annulla</button>
        <button class="btn btn-default-reverse btn-sm  bt-tenant"  data-dismiss="modal" type="button" (click)="changeTenant()">Ok</button>
      </div>
    </div>
  </div>
</div>
